<div class="dialog-content-wrapper" cslPerfectScrollbar>
  <div mat-dialog-title>
    <span class="title dialog-title" i18n>База материалов</span>
    <button mat-button class="mat-icon-button" (click)="dialogRef.close([])" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- MENU -->
  <div class="px-4 py-2">
    <mat-form-field floatLabel="never" appearance="outline" class="dense-input no-subscript flex-1 w-full">
      <input matInput #filter placeholder="Поиск" i18n-placeholder />
      <div matSuffix>
        <button mat-icon-button #filterButton>
          <mat-icon class="secondary-text">search</mat-icon>
        </button>
      </div>
    </mat-form-field>
  </div>
  <!-- MENU END -->

  <mat-divider> </mat-divider>

  <div mat-dialog-content class="p-0 pb-0 m-0 ps flex flex-row items-stretch">
    <div class="groups-tree basis-[260px] lg:basis-[320px]">
      <csl-group-matrial-tree
        class="ps flex-1"
        [groupMaterials]="furnitureGroups"
        [focusedGroupId]="focusedGroupId"
        (selectedGroupChange)="onGroupSelect($event)">
      </csl-group-matrial-tree>
    </div>

    <div cslPerfectScrollbar class="flex flex-col items-stretch basis-4/5">
      <!-- <div style="max-height: 40vh; height: 40vh;"> -->
      <mat-table #table [dataSource]="dataSource" class="furniture-list-table">
        <!-- Select Column -->
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let item">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? toggleSelected(item) : null"
              [checked]="selection.isSelected(item.id)"
              [disabled]="item.quantityInStock < 0 && showQuantityInStock">
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <!-- Texture Column -->
        <ng-container matColumnDef="texture">
          <mat-header-cell *matHeaderCellDef i18n>Текстура</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <ng-container *ngIf="!item.textureName && item.color; then showColor; else showTexture"> </ng-container>
            <ng-template #showColor>
              <div class="mw-texture mw-color" [ngStyle]="{ 'background-color': '#' + item.color }"></div>
            </ng-template>
            <ng-template #showTexture>
              <img
                (click)="openTextureViewerDialog(item.textureLink)"
                *ngIf="item.textureName !== ''"
                class="mw-texture"
                src="{{ item.cropTextureLink }}"
                (error)="setImagePlug($event)" />
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef i18n>Наименование</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <span class="h6 p-1">{{ item.name }}</span>
          </mat-cell>
        </ng-container>

        <!-- Article Column -->
        <ng-container matColumnDef="article">
          <mat-header-cell *matHeaderCellDef i18n>Артикул</mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.article }}
          </mat-cell>
        </ng-container>

        <!-- Size Column -->
        <ng-container matColumnDef="size">
          <mat-header-cell *matHeaderCellDef i18n>Габариты</mat-header-cell>
          <mat-cell *matCellDef="let item"> {{ item.width }}&times;{{ item.height }} </mat-cell>
        </ng-container>

        <!-- Price Column -->
        <ng-container matColumnDef="price">
          <mat-header-cell *matHeaderCellDef i18n>Цена</mat-header-cell>
          <mat-cell *matCellDef="let item"> {{ item.price }}{{ currencySymbol }}/{{ item.measureName }} </mat-cell>
        </ng-container>

        <!--Quantity Material Stock Column-->
        <ng-container matColumnDef="quantityInStock">
          <mat-header-cell *matHeaderCellDef i18n>Наличие на складе</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <span *ngIf="item.quantityInStock > 0"> {{ item.quantityInStock }} {{ item.measureName }} </span>
            <span i18n *ngIf="item.quantityInStock === 0">Под заказ</span>
            <span 18n *ngIf="item.quantityInStock === -1"> Нет в наличии </span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row class="material-list-row" *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <!-- </div> -->

      <div class="flex flex-row justify-center">
        <button
          class="m-16"
          color="accent"
          *ngIf="hasMore && !loading"
          (click)="loadMore$.next([loadMore$.value[0] + 1, loadMore$.value[1]])"
          mat-stroked-button
          i18n
          >Загрузить еще</button
        >
        <mat-spinner *ngIf="loading" class="m-32" [diameter]="16"> </mat-spinner>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions>
    <button mat-raised-button class="mat-accent mr-4" (click)="saveAndClose()" i18n>ОК</button>
    <button mat-button (click)="dialogRef.close([])" i18n>ОТМЕНА</button>
  </div>
</div>
